import type {
	InvestmentCreateFormInput,
	InvestmentEditFormInput,
} from "web_myplann/Portfolio/Forms/InvestmentForm/investmentFormSchema";

export const INVESTMENT_EDIT_FORM_DEFAULT_VALUES: InvestmentEditFormInput = {
	name: "",
	contractNumber: "",
	producer: "",
	product: "",
	signedAt: null,
	startAt: null,
	endAt: null,
	tools: [],
};

export const INVESTMENT_CREATE_FORM_DEFAULT_VALUES: InvestmentCreateFormInput =
	{
		...INVESTMENT_EDIT_FORM_DEFAULT_VALUES,
		value: null,
		invested: null,
		valueDate: null,
	};

export const getInvestmentCreateFormDefaultValues =
	(): InvestmentCreateFormInput => ({
		...INVESTMENT_CREATE_FORM_DEFAULT_VALUES,
		valueDate: new Date(),
	});
